var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 84,
    viewBox: "0 0 88 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0706 33.7301C30.6504 32.1503 32.7932 31.2627 35.0275 31.2627H43.8953C46.1296 31.2627 48.2723 32.1503 49.8522 33.7301C51.4321 35.31 52.3197 37.4528 52.3197 39.6871V40.1305H66.0647C68.2686 40.1305 70.0552 41.9171 70.0552 44.121V79.5921C70.0552 81.796 68.2686 83.5826 66.0647 83.5826H21.7258C19.522 83.5826 17.7354 81.796 17.7354 79.5921V52.9887C17.7354 50.7849 19.522 48.9982 21.7258 48.9982H26.6031V39.6871C26.6031 37.4528 27.4907 35.31 29.0706 33.7301ZM25.7163 56.9792V75.6016H44.3387V56.9792H25.7163ZM44.3387 48.9982H34.5841V39.6871C34.5841 39.5695 34.6308 39.4567 34.714 39.3736C34.7971 39.2904 34.9099 39.2437 35.0275 39.2437H43.8953C44.0129 39.2437 44.1257 39.2904 44.2088 39.3736C44.292 39.4567 44.3387 39.5695 44.3387 39.6871V48.9982ZM52.3197 75.6016H62.0742V48.1115H52.3197V75.6016Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2748 0.569521C43.3066 0.110941 44.4844 0.110941 45.5162 0.569521L85.4212 18.3051C86.8623 18.9456 87.791 20.3746 87.791 21.9516V79.5922C87.791 81.7961 86.0044 83.5827 83.8005 83.5827C81.5966 83.5827 79.81 81.7961 79.81 79.5922V24.545L43.8955 8.58296L7.981 24.545V79.5922C7.981 81.7961 6.19439 83.5827 3.9905 83.5827C1.78661 83.5827 0 81.7961 0 79.5922V21.9516C0 20.3746 0.928723 18.9456 2.3698 18.3051L42.2748 0.569521Z",
    fill: "#D7DBE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.0220939974967530eca35f35eb39deaf.svg";
export { ForwardRef as ReactComponent };